import React from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, XIcon } from 'lucide-react';

import { Button } from '@/component-library/primitives/Button/Button';

interface AlertDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onClose: () => void;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({ isOpen, title, message, confirmLabel = 'OK', onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000]" onClick={onClose}>
      <div className="bg-white rounded-lg p-6 w-96 max-w-full mx-4 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-custom-red flex items-center justify-center">
              <AlertTriangle className="text-white" size={24} />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-black mb-2">{title}</h3>
            <p className="text-md text-custom-darkSilver whitespace-pre-wrap">{message}</p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 text-custom-darkSilver hover:text-custom-black transition-colors"
          >
            <XIcon size={16} />
          </button>
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <Button onClick={onClose} variant="transparent">
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
